shadow$provide[525] = function(require,module,exports) {
var require$_DOT__SLASH_compile = require("./compile");
var require$_DOT__SLASH_parse = require("./parse");
var require$_DOT__SLASH_generate = require("./generate");
var require$_DOT__SLASH_constants = require("./constants");
require.exportCopy(module, require$_DOT__SLASH_compile);
require.exportCopy(module, require$_DOT__SLASH_parse);
require.exportCopy(module, require$_DOT__SLASH_generate);
require.exportCopy(module, require$_DOT__SLASH_constants);

};